<template>
  <div style="width: 100%">
    <keep-alive>
      <ExcepcionesSupervisorOferta v-if="menu.state == 'home'" />
      <ExcepcionesSupervisorDetalle v-if="menu.state == 'detail'" />
    </keep-alive>
  </div>
</template>

<script>
import { default as ExcepcionesSupervisorOferta } from "./Excepciones_Supervisor_Ofertas.vue";
import { default as ExcepcionesSupervisorDetalle } from "./Excepciones_Supervisor_Detalle.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "botonPanico",
  components: {
    ExcepcionesSupervisorOferta,
    ExcepcionesSupervisorDetalle,
  },
  data: () => ({
    loading: false,
  }),
  mounted() {},
  computed: {
    ...mapGetters("horarios", ["menu"]),
  },
  methods: {},
};
</script>

<style scoped>
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #a4a0a0 !important;
}
</style>
